import DetailsRow from "./DetailsRow";

export default class BaseTaskRow extends DetailsRow {
    appendOddEvenPrefix(baseClass) {
        return (this.isOddRow() ? "odd" : "even") + " " + baseClass;
    }

    getTopBorderClass() {
        if (this.isFirstChildRow())
            return "detailsRowSeparator";

        if (this.hasRowSeparator())
            return "detailsInnerRowSeparator";
    }

    hasRowSeparator() {
        let childRows = this.getParentRow().getChildRows();
        for (let i = 0; i < childRows.length; i++) {
            let childRow = childRows[i];
            if (childRow instanceof BaseTaskRow) {
                return childRow.getRowIdx() == this.getRowIdx();
            }
        }
    }

    isOddRow() {
        let childRows = this.getParentRow().getChildRows();
        let firstTaskRow = null;
        for (let i = 0; i < childRows.length; i++) {
            let childRow = childRows[i];
            if (childRow instanceof BaseTaskRow) {
                if (firstTaskRow == null)
                    firstTaskRow = childRow;

                if (childRow.getRowIdx() == this.getRowIdx())
                    return (childRow.getRowIdx() - firstTaskRow.getRowIdx()) % 2;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/BaseTaskRow.js